import Vue from 'vue';
import Vuex from 'vuex';
import VueResource from 'vue-resource';
import VuexPersistence from 'vuex-persist';
// import VuexSharedMutations from 'vuex-shared-mutations';

import Cookies from 'js-cookie';
import user from '@/store/_user';
import layout from '@/store/_layout';
import cache from '@/store/_cache';
import betsingle from '@/store/_betsingle';
import betparlay from '@/store/_betparlay';
import betsinglemmo from '@/store/_betsinglemmo';
import betparlaymmo from '@/store/_betparlaymmo';
import timemachine from '@/store/_timemachine';

import config from '@/config';
import league from '@/library/_league';

Vue.use(VueResource);
Vue.use(Vuex);

// const STORAGE_KEY = 'sb2019110803';
const STORAGE_KEY = 'mr2gqwwRvpDzgfOSB6G0R8NyNHCK9dnc';

const cookieStorage = new VuexPersistence({
  key: STORAGE_KEY,
  restoreState: (key, storage) => Cookies.getJSON(key),
  saveState: (key, state, storage) =>
    Cookies.set(key, state, {
      expires: new Date(new Date().getTime() + 24 * 60 * 60 * 1000)
    }),
  reducer: state => ({
    user: {
      account: state.user.account
    }
  })
});

const sessionStorage = new VuexPersistence({
  key: STORAGE_KEY,
  storage: window.localStorage,
  reducer: state => ({
    layout: state.layout
  })
});

const store = new Vuex.Store({
  strict: true,
  modules: {
    user,
    layout,
    cache,
    betsingle,
    betparlay,
    betsinglemmo,
    betparlaymmo,
    timemachine
  },
  state: {
    defaultInterval: config.defaultInterval,
    interval: config.initialInterval,
    defaultDelay: config.defaultDelay
  },
  mutations: {
    updateMode(state, payload) {
      state.interval = state.defaultInterval * payload;
    }
  },
  actions: {
    setMode(context, payload) {
      context.commit("updateMode", payload);
    }
  },
  getters: {
    whiteLabel: state => {
      if (config.whiteLabel == "1") {
        return {
          mode: true,
          theme: state.layout.theme
        };
      } else {
        return {
          mode: false,
          theme: ""
        };
      }
    },
    countKey: state => {
      return state.cache.countKey;
    },
    data: state => {
      return state.cache;
    },
    selectedMatch: state => {
      return state.layout.selectedMatch;
    },
    selectedMatchMore: state => {
      return state.layout.selectedMatchMore;
    },
    selectLeague: state => {
      return state.layout.selectLeague;
    },
    selectedDays: state => {
      return state.layout.selectedDays;
    },
    upcomingHours: state => {
      return state.layout.upcomingHours;
    },
    search: state => {
      return state.layout.search;
    },
    betting: state => {
      return state.layout.betting;
    },
    pageDisplay: state => {
      return state.layout.pageDisplay;
    },
    language: state => {
      return state.layout.pageDisplay.language;
    },
    odds: state => {
      return state.layout.odds;
    },
    menuX: state => {
      return state.layout.menuX;
    },
    menu0: state => {
      return state.layout.menu0;
    },
    menu1: state => {
      return state.layout.menu1;
    },
    menu2: state => {
      return state.layout.menu2;
    },
    menu3: state => {
      return state.layout.menu3;
    },
    menu4: state => {
      return state.layout.menu4;
    },
    minimizer: state => {
      return state.layout.minimizer;
    },
    pageSize: state => {
      return state.layout.pageDisplay.pageSize;
    },
    playerInfo: state => {
      if (state.user.account) {
        if (state.user.account.player_info) {
          if (state.user.account.player_info) {
            return state.user.account.player_info;
          }
        }
      }
      return {};
    },
    playerWallet: state => {
      if (state.user.account) {
        if (state.user.account.player_wallet) {
          if (state.user.account.player_wallet) {
            return state.user.account.player_wallet;
          }
        }
      }
      return {};
    },
    playerBetLimit: state => {
      if (state.user.account) {
        if (state.user.account.player_bet_limit) {
          if (state.user.account.player_bet_limit) {
            return state.user.account.player_bet_limit;
          }
        }
      }
      return {};
    },
    operatorType: (state, getters) => {
      if ("operator_type" in getters.playerInfo) return getters.playerInfo.operator_type;
      return null;
    },
    parentId: (state, getters) => {
      if ("parent_id" in getters.playerInfo) return getters.playerInfo.parent_id;
      return null;
    },
    sessionToken: (state, getters) => {
      if ("session_token" in getters.playerInfo) return getters.playerInfo.session_token;
      return null;
    },
    balance: (state, getters) => {
      if ("available_balance" in getters.playerWallet) return getters.playerWallet.available_balance;
      return null;
    },
    accountId: (state, getters) => {
      if ("account_id" in getters.playerInfo) return getters.playerInfo.account_id;
      return null;
    },
    mmoMode: (state, getters) => {
      if (getters.currencyCode) {
        return config.mmoSupport && ['MMK','MMO'].includes(getters.currencyCode);
      } else {
        return false;
      }
    },
    currencyCode: (state, getters) => {
      if ("currency_code" in getters.playerWallet) return getters.playerWallet.currency_code;
      return null;
    },
    commType: (state, getters) => {
      if ("comm_type" in getters.playerInfo) return getters.playerInfo.comm_type;
      return null;
    },
    nickName: (state, getters) => {
      if ("account_id" in getters.playerInfo) return getters.playerInfo.nickname;
      return null;
    },
    hasSecondaryAccount: (state, getters) => {
      if ("account_id" in getters.playerInfo) return getters.playerInfo.has_secondary_account;
      return null;
    },
    isLoggedIn: (state, getters) => {
      if (getters.sessionToken) {
        return true;
      } else {
        return false;
      }
    },
    favorite: (state, getters) => {
      return state.layout.favorite;
    },
    leagueType: (state, getters) => {
      return state.layout.leagueType;
    },
    // cache.league is keyed by league id. layout.league is the raw feed list (m.ln),
    // indexed by response position, so rows[id] there misses and kind() falls through to "normal".
    leagueKindOf: (state) => (id) => {
      var rows = state.cache.league;
      return league.kind(rows && id != null ? rows[id] : null);
    },
    leagueKindClassOf: (state, getters) => (id) => {
      if (!config.leagueKindColors) return "";
      return league.kindClass(getters.leagueKindOf(id));
    },
    timeMachine: (state, getters) => {
      return state.timemachine;
    }
  },
  plugins: [
    sessionStorage.plugin,
    cookieStorage.plugin
    // VuexSharedMutations({
    //   predicate: [
    //     "user/updateAccount",
    //     "user/deleteAccount",
    //     "user/updateBalance",
    //     "user/updateNickname",
    //     "layout/updateMenuList",
    //     "layout/resetState",
    //     "layout/clearSelectLeague",
    //     "layout/updateSelectLeague",
    //     "layout/updateSelectedMatch",
    //     "layout/updateSearch",
    //     "layout/updateOptions",
    //     "layout/updateSports",
    //     "layout/updateLeague",
    //     "layout/updateOrder",
    //     "layout/updateLanguage",
    //     "layout/updatePageDisplay",
    //     "layout/updateSingleBetting",
    //     "layout/updateBetting",
    //     "layout/updateMenu",
    //     "layout/updateMenuItems",
    //     "layout/updateMinimizer",
    //     "layout/updateSelectedDays",
    //     "layout/updateFavorite",
    //     "layout/removeFavorite",
    //     "layout/replaceFavorite"
    //   ]
    // })
  ]
});

export default store;
